import { useSelector } from 'react-redux';
import robotLevel1Svg from '../../Components/Icons/Power/robot/robot_level1.svg';
import robotChargingLevel1Svg from '../../Components/Icons/Power/robot/robot_level1_charging.svg';
import robotChargingLevel1SvgDark from '../../Components/Icons/Power/robot/robot_level1_charging_dark.svg';
import robotLevel1SvgDark from '../../Components/Icons/Power/robot/robot_level1_dark.svg';
import robotLevel2Svg from '../../Components/Icons/Power/robot/robot_level2.svg';
import robotChargingLevel2Svg from '../../Components/Icons/Power/robot/robot_level2_charging.svg';
import robotChargingLevel2SvgDark from '../../Components/Icons/Power/robot/robot_level2_charging_dark.svg';
import robotLevel2SvgDark from '../../Components/Icons/Power/robot/robot_level2_dark.svg';
import robotLevel3Svg from '../../Components/Icons/Power/robot/robot_level3.svg';
import robotChargingLevel3Svg from '../../Components/Icons/Power/robot/robot_level3_charging.svg';
import robotChargingLevel3SvgDark from '../../Components/Icons/Power/robot/robot_level3_charging_dark.svg';
import robotLevel3SvgDark from '../../Components/Icons/Power/robot/robot_level3_dark.svg';
import robotLevel4Svg from '../../Components/Icons/Power/robot/robot_level4.svg';
import robotChargingLevel4Svg from '../../Components/Icons/Power/robot/robot_level4_charging.svg';
import robotChargingLevel4SvgDark from '../../Components/Icons/Power/robot/robot_level4_charging_dark.svg';
import robotLevel4SvgDark from '../../Components/Icons/Power/robot/robot_level4_dark.svg';
import robotLevel5Svg from '../../Components/Icons/Power/robot/robot_level5.svg';
import robotChargingLevel5Svg from '../../Components/Icons/Power/robot/robot_level5_charging.svg';
import robotChargingLevel5SvgDark from '../../Components/Icons/Power/robot/robot_level5_charging_dark.svg';
import robotLevel5SvgDark from '../../Components/Icons/Power/robot/robot_level5_dark.svg';
import { RootState } from '../../redux/Store';
import { BATTERY_STATES, POWER_STATES, RobotActions } from '../../utils/constants';

const { STATE } = RobotActions;

const POWER_ICONS = {
  charging_level1: { light: robotChargingLevel1Svg, dark: robotChargingLevel1SvgDark },
  charging_level2: { light: robotChargingLevel2Svg, dark: robotChargingLevel2SvgDark },
  charging_level3: { light: robotChargingLevel3Svg, dark: robotChargingLevel3SvgDark },
  charging_level4: { light: robotChargingLevel4Svg, dark: robotChargingLevel4SvgDark },
  charging_level5: { light: robotChargingLevel5Svg, dark: robotChargingLevel5SvgDark },
  level1: { light: robotLevel1Svg, dark: robotLevel1SvgDark },
  level2: { light: robotLevel2Svg, dark: robotLevel2SvgDark },
  level3: { light: robotLevel3Svg, dark: robotLevel3SvgDark },
  level4: { light: robotLevel4Svg, dark: robotLevel4SvgDark },
  level5: { light: robotLevel5Svg, dark: robotLevel5SvgDark },
} as const;

export type PowerIconColorMode = 'light' | 'dark';

const usePowerStateIcon = (colorMode: PowerIconColorMode): JSX.Element | null => {
  const { robotState, batteryCharging, powerLevel, powerState } = useSelector((state: RootState) => state.robot);

  if (robotState !== STATE.CONNECTED) {
    return null;
  }

  const isDark = colorMode === 'dark';
  const pick = (key: keyof typeof POWER_ICONS) => (isDark ? POWER_ICONS[key].dark : POWER_ICONS[key].light);

  let src: string;
  if (powerState === POWER_STATES.LOW || powerState === POWER_STATES.CRITICAL) {
    src = pick(batteryCharging ? 'charging_level1' : 'level1');
  } else {
    switch (String(powerLevel)) {
      case BATTERY_STATES.LEVEL5:
        src = pick(batteryCharging ? 'charging_level5' : 'level5');
        break;
      case BATTERY_STATES.LEVEL4:
        src = pick(batteryCharging ? 'charging_level4' : 'level4');
        break;
      case BATTERY_STATES.LEVEL3:
        src = pick(batteryCharging ? 'charging_level3' : 'level3');
        break;
      case BATTERY_STATES.LEVEL2:
        src = pick(batteryCharging ? 'charging_level2' : 'level2');
        break;
      case BATTERY_STATES.LEVEL1:
        src = pick(batteryCharging ? 'charging_level1' : 'level1');
        break;
      default:
        // powerLevel is null before the first fuel-gauge event; use level3 as a
        // conservative mid-range fallback rather than an optimistic full-charge icon.
        src = pick(batteryCharging ? 'charging_level3' : 'level3');
    }
  }

  return <img src={src} alt="" width={24} height={24} />;
};

export default usePowerStateIcon;
